<template>
  <!-- <div> -->
  <!-- <pre style='font-size: 10px;'>color = {{ color }}</pre> -->
  <!-- <pre style='font-size: 10px;'>alpha = {{ alpha }}</pre> -->
  <!-- <pre style='font-size: 10px;'>_color = {{ _color }}</pre> -->
  <!-- <pre style='font-size: 10px;'>_colorHex = {{ _colorHex }}</pre> -->
  <!-- <pre style='font-size: 10px;'>_colorCSS = {{ _colorCSS }}</pre> -->
  <!-- <pre style='font-size: 10px;'>_colorHexThreshold = {{ _colorHexThreshold }}</pre> -->
  <div
    style="
      position: relative;
      width: 32px;
      height: 32px;
      padding: 3px;
      border-radius: 4px;
      border: 1px solid #dee3e6;
      background-color: #ffffff;
    "
  >
    <div
      :style="`
        position: absolute;
        top: 3px;
        left: 3px;
        width: 24px;
        height: 24px;
        border-radius: 2px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
        background-position: top left;
      `"
    ></div>
    <div
      :style="`
        position: absolute;
        top: 3px;
        left: 3px;
        width: 24px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid ${_colorHexThreshold > 0.97 ? '#DEE3E6' : _colorCSS};
        background-color: ${_colorCSS};
      `"
    >
      <span
        v-if="isShowIcon"
        :style="`color: ${
          _colorHexThreshold > 0.97 ? '#DEE3E6' : '#FFFFFF'
        } !important`"
      >
        <i class="far fa-tint"></i>
      </span>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    color: {
      type: String,
      required: true,
    },
    alpha: {
      type: [String, Number],
      default: 100,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isShowIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      module: "module",
      // templateColor: "design/metadata/templateColor",
    }),
    templateColor() {
      return this.$store.getters[`${this.module}/metadata/templateColor`];
    },
    _color() {
      return this.color;
    },
    _alpha() {
      return this.alpha;
    },
    _colorHex() {
      if (this.color.startsWith("--")) {
        let strRGB = this.templateColor[this.color]; // --tpc-15 => x,x,x
        let arrRGB = strRGB.split(",");
        return this.$helper.color
          .rgbToHex(arrRGB[0], arrRGB[1], arrRGB[2])
          .toUpperCase(); // #xxxxxx
      }
      if (this.color.startsWith("rgb(")) {
        let strRGB = this.color.replace("rgb(", "").replace(")", ""); // rgb(x,x,x) => x,x,x
        let arrRGB = strRGB.split(",");
        return this.$helper.color
          .rgbToHex(arrRGB[0], arrRGB[1], arrRGB[2])
          .toUpperCase(); // #xxxxxx
      }
      return this.color.toUpperCase(); // ?
    },
    _colorHexThreshold() {
      return this.$helper.color.hexThreshold(this._colorHex);
    },
    _colorCSS() {
      return this.$helper.color.getColor(this._colorHex, this._alpha); // #xxxxxxAA
    },
  },
};
</script>

<style></style>
